/**
 * 미응답 안내 규칙(총괄 DEV-I-003 항목 2, DEV-I-004 항목 2). 시작 전 과제 정보와 풀이 화면이 이 함수 하나를 쓴다.
 * 입력은 응답 방식 목록이다: 시작 전 정보는 서버가 배포 판에서 계산한 assignment.release.responseModes,
 * 풀이 화면은 받은 문항의 responseMode. 안내만 하며 제출 판정은 서버가 한다.
 * 요약이 없거나 비어 있으면 일반 객관식 과제로 간주하지 않고 중립 안내를 쓴다(DEV-I-005 항목 4).
 * 서버 규칙: GR 지점은 미응답 허용과 관계없이 모두 골라야 하고, 미응답 허용은 일반 객관식에만 적용된다.
 *  - 일반 객관식 + GR, 허용: 총괄 지정 문구
 *  - GR만: 일반 객관식 안내 없이 지점 규칙만
 *  - 일반 객관식만 / 일반 객관식 + GR 불허: 개발 제안 문구(총괄 미지정)
 */
import type { ItemView } from './types.js';

export type ResponseMode = ItemView['responseMode'];
export const GUIDE_MIXED_ALLOW = '일반 객관식은 답하지 않아도 제출할 수 있어요. GR은 모든 지점에서 보기를 하나씩 골라 주세요.';

/** 응답 방식 요약이 없을 때(서버 v0.6.1 미만 등): 문항 유형을 추정하지 않고 중립 안내(DEV-I-005 항목 4) */
export const GUIDE_UNKNOWN = '제출 조건을 확인할 수 없어요. 풀기 시작하면 문항에 맞는 안내가 나와요.';

export function unansweredGuide(allowUnanswered: boolean, modes: readonly ResponseMode[] | null | undefined): string {
  if (modes === null || modes === undefined || modes.length === 0) return GUIDE_UNKNOWN;
  const hasChoice = modes.includes('single-choice');
  const hasGr = modes.includes('gr-points');
  if (hasGr && !hasChoice) return '모든 지점에서 보기를 하나씩 골라야 제출할 수 있어요.';
  if (hasGr) return allowUnanswered ? GUIDE_MIXED_ALLOW : '모든 문항에 답해야 제출할 수 있어요. GR은 모든 지점에서 보기를 하나씩 골라 주세요.';
  return allowUnanswered ? '답하지 않은 문항이 있어도 제출할 수 있어요.' : '모든 문항에 답해야 제출할 수 있어요.';
}

/** 문항 목록 → 응답 방식 목록(풀이 화면용) */
export const modesOf = (items: readonly Pick<ItemView, 'responseMode'>[]): ResponseMode[] => [...new Set(items.map((it) => it.responseMode))];
